import type { RawPromptCommand, PromptCommandCategorySerialized } from '~/lib/stores/command/types';
import type { FeaturePreviews } from '~/types/feature-previews';
import type { ThemeOption } from '~/types/theme';

export const DEFAULT_SETTINGS: Settings = {
  general: {
    showTokenUsageInChat: false,
    forceShowSubscribeBannerInChat: false,
  },
  appearance: {
    theme: 'dark',
  },
  shortcuts: {
    toggleTerminal: {
      key: 'j',
      ctrlOrMetaKey: true,
    },
  },
  editor: {
    lineWrapping: true,
  },
  featurePreviews: {
    reasoning: false,
    diffs: false,
  },
  knowledge: {
    systemPrompt: '',
  },
  commandPalette: {
    customPromptCategories: [],
    customPrompts: [],
    favoritedCommands: [],
  },
  hosting: {
    monthlySpendingLimit: 0,
  },
};

export interface Shortcut {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
  ctrlOrMetaKey?: boolean;
}

export interface Shortcuts {
  toggleTerminal: Shortcut;
}

export interface EditorSettings {
  lineWrapping: boolean;
}

export type Settings = {
  general: {
    showTokenUsageInChat: boolean;
    forceShowSubscribeBannerInChat: boolean;
  };
  shortcuts: Shortcuts;
  appearance: {
    theme: ThemeOption;
  };
  editor: EditorSettings;
  featurePreviews: FeaturePreviews;
  knowledge: {
    systemPrompt: string;
  };
  commandPalette: {
    customPromptCategories: PromptCommandCategorySerialized[];
    customPrompts: RawPromptCommand[];
    favoritedCommands: string[];
  };
  hosting: {
    monthlySpendingLimit: number;
  };
};

export type APISettings = {
  [C in keyof Settings]?: {
    [K in keyof Settings[C]]?: Settings[C][K];
  };
};
